import React from 'react';
import { Star, ExternalLink } from 'lucide-react';

/**
 * Компонент с популярными редиректами для быстрой проверки
 */
const PopularRedirects = ({ onCheckUrl }) => {
  // Список популярных редиректов для российских сайтов
  const popularRedirects = [
    { name: 'Редирект с HTTP на HTTPS', url: 'http://yandex.ru', description: 'Перенаправление с незащищенного на защищенный протокол' },
    { name: 'Редирект на WWW', url: 'ya.ru', description: 'Перенаправление с домена без www на домен с www' },
    { name: 'Редирект с www на без www', url: 'www.vk.com', description: 'Перенаправление с www на домен без www-префикса' },
    { name: 'Редирект со слэшем', url: 'ozon.ru', description: 'Перенаправление с домена без слэша на домен со слэшем' },
    { name: 'Редирект с RU на РФ', url: 'президент.рф', description: 'Перенаправление между кириллическим и латинским доменом' },
    { name: 'Мобильная версия', url: 'avito.ru', description: 'Обработка редиректов на мобильную версию сайта' }
  ];

  return (
    <div className="bg-white dark:bg-gray-800 rounded-xl border border-gray-200 dark:border-gray-700 p-5 shadow-sm">
      <h3 className="text-lg font-medium text-gray-900 dark:text-white mb-4 flex items-center">
        <Star className="w-5 h-5 mr-2 text-indigo-500" />
        Популярные редиректы
      </h3>
      
      <div className="space-y-3">
        {popularRedirects.map((item, index) => (
          <div 
            key={index} 
            className="bg-gray-50 dark:bg-gray-700/30 border border-gray-200 dark:border-gray-700 rounded-lg p-3 hover:bg-gray-100 dark:hover:bg-gray-700 transition-colors"
          >
            <div className="flex justify-between items-start">
              <div className="flex-grow">
                <h4 className="text-sm font-medium text-gray-900 dark:text-white">
                  {item.name}
                </h4>
                <div className="text-xs text-indigo-600 dark:text-indigo-400 mt-0.5 group-hover:underline">
                  {item.url}
                </div>
              </div>
              <button
                onClick={() => onCheckUrl(item.url)}
                className="ml-2 p-1 text-gray-500 hover:text-indigo-600 dark:text-gray-400 dark:hover:text-indigo-400"
                title="Проверить этот URL"
              >
                <ExternalLink className="w-4 h-4" />
              </button>
            </div>
            <p className="mt-1 text-xs text-gray-500 dark:text-gray-400">
              {item.description}
            </p>
          </div>
        ))}
      </div>
      
      <div className="mt-4 p-3 bg-indigo-50 dark:bg-indigo-900/20 border border-indigo-100 dark:border-indigo-800 rounded-lg">
        <div className="text-sm text-indigo-700 dark:text-indigo-300">
          <h4 className="font-medium mb-1">Знаете ли вы?</h4>
          <p className="text-xs">
            В России Яндекс уделяет особое внимание редиректам между поддоменами для региональных версий сайтов, оценивая их корректность при ранжировании. Правильная настройка редиректов с доменов .ru на .рф и наоборот также важна для SEO в Рунете.
          </p>
        </div>
      </div>
    </div>
  );
};

export default PopularRedirects;